import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/** 门户支持的语言 */
export const LOCALES = ['zh', 'en'] as const
export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'zh'

/** localStorage 持久化 key */
export const LOCALE_STORAGE_KEY = 'trust.locale'

interface LocaleState {
  locale: Locale
  setLocale: (locale: Locale) => void
  toggleLocale: () => void
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set, get) => ({
      locale: DEFAULT_LOCALE,
      setLocale: (locale) => set({ locale }),
      toggleLocale: () => set({ locale: get().locale === 'zh' ? 'en' : 'zh' }),
    }),
    {
      name: LOCALE_STORAGE_KEY,
      partialize: (s) => ({ locale: s.locale }),
    },
  ),
)

/** 非 React 环境读取当前语言 */
export function getLocale(): Locale {
  return useLocaleStore.getState().locale
}

/** 非 React 环境切换语言(组件内直接用 useLocaleStore 或这两个函数均可) */
export function setLocale(locale: Locale): void {
  useLocaleStore.getState().setLocale(locale)
}

export function toggleLocale(): void {
  useLocaleStore.getState().toggleLocale()
}

/** React hook:订阅当前语言(切换后触发重渲染) */
export function useLocale(): Locale {
  return useLocaleStore((s) => s.locale)
}

/** 切换语言时同步 <html lang>,供浏览器/屏幕阅读器识别 */
export function htmlLang(locale: Locale): string {
  return locale === 'zh' ? 'zh-CN' : 'en'
}

if (typeof document !== 'undefined') {
  document.documentElement.lang = htmlLang(getLocale())
  useLocaleStore.subscribe((s) => {
    document.documentElement.lang = htmlLang(s.locale)
  })
}
